import React from 'react'
import { Link } from 'react-router-dom'

import { Modal, ModalBody } from 'reactstrap'

import { getList, deleteObj, getStructList, saveObj } from '../../store/api.js'

import Lottie from "lottie-react"
import lottiejson from "../../assets/error-grub.json"
import lottieAlerta from "../../assets/cuidado-alerta.json"

class ListaOpcional extends React.Component {

	constructor(props) {
		super(props)

		const user = JSON.parse(localStorage.getItem('user')).data
		this.state = {
			brand: user.brand ? user.brand : "",
			model:null,
			lista:[],
			struct:[],
			opcional:null,
			modalAlert: false,
			OBJID: null,
			modalOcupada:null
		}

		this.fetchData = this.fetchData.bind(this)
		this.handlerPagination = this.handlerPagination.bind(this)
		this.deleteItem = this.deleteItem.bind(this)
		this.habilitaItem = this.habilitaItem.bind(this)
	}

	fetchData(){
		if (this.state.model !== this.props.model) {
			getStructList(this.props.model).then(result => {
				this.setState({ struct: result })
			})

			getList(this.props.model).then(result => {

				console.log(result.data)
				this.setState({ lista: result.data })
			})

			this.setState({model: this.props.model})
		}
	}

	async deleteItem(e){
		e.preventDefault()

		await deleteObj('Opcional/'+this.state.OBJID)
		this.setState({ modalAlert: false, OBJID: null })
		getList(this.props.model).then(result => {
			this.setState({ lista: result.data })
		})
	}

	componentDidMount() {
		this.fetchData()
	}

	handlerPagination(e){
		getList(this.state.model, {page:e.target.dataset.page}).then(result =>
			this.setState({ lista: result.data })
		)
	}

	async habilitaItem(e, status){
		e.preventDefault()

		console.log(e.target.dataset.obj, status)
		if (status == '0') {
			await saveObj({items:{id: e.target.dataset.obj, status:1}}, "Opcional")
		} else {
			await saveObj({items:{id: e.target.dataset.obj, status:0}}, "Opcional")
		}

		getList(this.props.model).then(result => {
			this.setState({ lista: result.data })
		})
	}
	
	render() {
		const lista = this.state.lista
		return (
			<div>
				{lista && lista.length > 0 ? (
					<div className="card border-0">
						
						<div className="tab-content p-3">
							
							<div className="tab-pane fade show active" id="allTab">
								
								<div className="table-responsive mb-3">
									<table className="table table-hover table-panel text-nowrap align-middle mb-0">
										<thead>
											<tr>
												<th></th>
												<th>Nome</th>
												<th>Valor</th>
												<th>Disponibilidade</th>
												<th>Ações</th>
											</tr>
										</thead>
										<tbody>
											{lista.length > 0 && lista.map((item) => 
												<tr key={"item_"+item.id}>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product1" />
															<label className="form-check-label" for="product1"></label>
														</div>
													</td>
													<td>
														<Link to={"/cardapio/edit/Opcional/"+item.id} style={{ textDecoration: 'none' }} >
															{item.nome}
														</Link>
													</td>
													<td>{item.valor}</td>
													<td>
														<div className="form-check form-switch">	
															<input className="form-check-input form-check-input-pos" data-obj={item.id} id={item.id} onClick={(e) => this.habilitaItem(e, item.status)} checked={item.status == '1' ? true : false}  type="checkbox" />
															<label className="form-check-label" htmlFor={item.id}> Ativo </label>
														</div>
													</td>
													<td>
														<button className="btn btn-white" data-opcional={item.id} onClick={(e) => {e.preventDefault(); this.setState({ modalAlert: true, OBJID: e.target.dataset.opcional })}}>
															<i className="fa fa-trash fs-9px fa-fw me-5px"></i> Excluir
														</button>
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				)
				:
				( 
					<div className="card border-0" style={{padding:"15px"}}>
						<Lottie animationData={lottiejson} loop={true} style={{width: "500px", margin:"auto"}} />
						<h1 style={{textAlign:"center"}}>Nenhum opcional cadastrado por aqui! Cadastre um agora. </h1>
						<p  style={{textAlign:"center"}}></p>
					</div>
				)
				}

				

				<Modal isOpen={this.state.modalAlert} toggle={() => this.setState({ modalAlert: false })}>
					<ModalBody>
						<div className='text-center'>
							<Lottie animationData={lottieAlerta} loop={true} style={{width: "250px", margin:"auto"}} />
							<div className="alert mb-15">
								<h3>Atenção: esta ação é crítica e irreversível.</h3>
								<p>Apagar o opcional pode acarretar em grandes transtornos. Após excluir o opcional, ele deixará de funcionar.</p>
							</div>
							
							<button className="btn btn-white" style={{marginRight: '15px'}} onClick={() => this.setState({ modalAlert: false })}>Cancelar</button>
							<button className="btn btn-danger" onClick={(e) => this.deleteItem(e)}>Sim, desejo eliminar este item</button>
						</div>
					</ModalBody>
				</Modal>

			
			</div>
		)
	}
}

export default ListaOpcional;